import React, { useContext, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import {
  FormsGlobalContext,
  SET_FAJITA_QUESTIONNAIRE_FORM,
} from '@mummssoftware/global-context';
import {
  Submitted,
  InProgress,
  STRING_FALSE,
  STRING_TRUE,
} from '@mummssoftware/utils/constants';
import { ConfirmStickyDialog } from '@mummssoftware/common-ui/ConfirmStickyDialog';
import { FajitaContext } from './Context';
import {
  SUBMIT_PLAN,
  SET_SUBMIT_PLAN_ACTIVE,
  DISCARD_FORM,
  SHOW_STICKIES,
  SHOW_STICKIES_CONFIRM_DIALOG,
} from './Context/constants';
import { SubmitPlanDiv } from '../../components/layout/WrapperDiv';
import { Context } from '../../context';
import defaults from '../../translations/en.json';

const useStyles = makeStyles(() => ({
  button: {
    lineHeight: '1',
    padding: '1px 5px',
  },
}));

export const SubmitPlan = () => {
  const { fajitaQuestionnaireFormGlobal, dispatchQuestionnaire } = useContext(
    FormsGlobalContext,
  );
  const formsGlobalContext = useContext(FormsGlobalContext);

  const { agency } = useContext(Context);
  const {
    dispatch,
    showStickies,
    showStickiesConfirmDialog,
    submitPlanActive,
  } = useContext(FajitaContext);
  const isSubmittingRef = useRef(false);

  useEffect(() => {
    if (!submitPlanActive) {
      isSubmittingRef.current = false;
    }
  }, [submitPlanActive]);
  const isInProgressFAJITA = fajitaQuestionnaireFormGlobal?.isInProgressFAJITA;
  const isNewFAJITAForm = !isInProgressFAJITA;
  const isSandBoxForm = fajitaQuestionnaireFormGlobal?.issandboxform;
  const isEditingSubmittedForm =
    (fajitaQuestionnaireFormGlobal as mumms.GenericForm | null)?.status ===
    Submitted;
  const classes = useStyles();

  const onDiscardPlan = async () => {
    if (submitPlanActive) {
      return;
    }
    if (showStickies) {
      // API call new form to be triggered
      dispatch({
        type: SHOW_STICKIES,
        payload: STRING_FALSE,
      });
    }
    // discard the form
    dispatch({
      type: DISCARD_FORM,
      payload: true,
    });

    // todo should I delete if stickies?
    // @note sticky is considered a new form
    // if (isNewFAJITAForm) {
    //   // delete endpoint
    //   formCache &&
    //     (await deletePatientManifestForm(formCache?.id as any, agency as any));
    // }

    setTimeout(() => {
      formsGlobalContext &&
        dispatchQuestionnaire({
          type: SET_FAJITA_QUESTIONNAIRE_FORM,
          payload: {
            ...fajitaQuestionnaireFormGlobal,
            reload: 1,
          },
        });
    }, 500);
  };

  const onSubmitPlan = (payload: { status: mumms.SubmitStatus }) => {
    if (
      !isEditingSubmittedForm &&
      showStickies === STRING_TRUE &&
      payload.status === Submitted
    ) {
      dispatch({
        type: SHOW_STICKIES_CONFIRM_DIALOG,
        payload: true,
      });
    } else {
      onConfirmSubmit(payload);
    }
  };

  const onConfirmSubmit = (payload: { status: mumms.SubmitStatus }) => {
    if (isSubmittingRef.current) {
      return;
    }
    isSubmittingRef.current = true;

    if (showStickiesConfirmDialog) {
      dispatch({
        type: SHOW_STICKIES_CONFIRM_DIALOG,
        payload: false,
      });
    }

    dispatch({
      type: SET_SUBMIT_PLAN_ACTIVE,
      payload: true,
    });

    dispatch({
      type: SUBMIT_PLAN,
      payload,
    });
  };

  const onCloseStickyDialog = () => {
    dispatch({
      type: SHOW_STICKIES_CONFIRM_DIALOG,
      payload: false,
    });
  };
  const showSubmit =
    fajitaQuestionnaireFormGlobal &&
    !fajitaQuestionnaireFormGlobal.isPrintViewFAJITA &&
    !fajitaQuestionnaireFormGlobal.isReadOnlyViewFAJITA;

  return showSubmit ? (
    <>
      <ConfirmStickyDialog
        open={showStickiesConfirmDialog}
        onSubmit={() => onConfirmSubmit({ status: Submitted })}
        onCancel={onCloseStickyDialog}
      />
      <SubmitPlanDiv>
        <Button
          type="submit"
          variant="contained"
          size="small"
          disabled={submitPlanActive}
          onClick={() => onDiscardPlan()}
          color="primary"
          classes={{
            root: classes.button,
          }}
        >
          {defaults.discardForm}
        </Button>
        {isEditingSubmittedForm ? null : (
          <Button
            type="submit"
            variant="contained"
            size="small"
            disabled={submitPlanActive}
            onClick={() => onSubmitPlan({ status: InProgress })}
            color="primary"
            classes={{
              root: classes.button,
            }}
          >
            {defaults.saveWIP}
          </Button>
        )}
        {isSandBoxForm ? null : (
          <Button
            type="submit"
            variant="contained"
            size="small"
            disabled={submitPlanActive}
            onClick={() => onSubmitPlan({ status: Submitted })}
            color="primary"
            classes={{
              root: classes.button,
            }}
          >
            {defaults.submit}
          </Button>
        )}
      </SubmitPlanDiv>
    </>
  ) : (
    <></>
  );
};
